import { Award, Sparkles } from "lucide-react";
import { cases, whatsappUrl } from "../mock";

function PhoneMock({ level, saldo, holder }) {
  return (
    <div className="phone-mock mx-auto">
      <div className="phone-screen">
        <div className="flex items-center justify-between text-[10px] text-emerald-100/70">
          <span>10:17</span>
          <span className="flex gap-1">●●●</span>
        </div>
        <div className="flex items-center justify-between text-[10px]">
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-5 rounded-full bg-emerald-500/30" />
            <span className="text-emerald-200 font-semibold">Saldo: {saldo}</span>
            <span className="text-[9px] text-amber-400 bg-amber-500/10 px-1 rounded">PRO</span>
          </div>
          <span className="text-emerald-300/80 text-[9px]">Ver extrato</span>
        </div>
        <div className="mt-2 bg-black/40 rounded-xl p-2">
          <div className="flex items-center justify-between text-[10px] text-emerald-100/80">
            <span>Reconhecimento</span>
            <span className="text-emerald-300">Ver toda a jornada</span>
          </div>
          <div className="mt-2 flex flex-col items-center">
            <div className="ring-progress">
              <div className="relative z-10 text-center">
                <div className="text-emerald-100 text-[9px]">{level}</div>
                <div className="text-white text-[10px] font-bold">{holder}</div>
                <div className="text-emerald-400 text-[10px] font-bold">99%</div>
              </div>
            </div>
            <div className="mt-2 flex items-center gap-2 text-[9px] text-emerald-200/80">
              <span>Prévia</span>
              <span className="text-white font-semibold">R$ 6.986,00</span>
            </div>
          </div>
        </div>
        <div className="mt-1 bg-black/40 rounded-xl p-2 text-[10px] text-emerald-100/80">
          <div>Meu saldo</div>
          <div className="text-white font-bold text-sm">Total acumulado</div>
        </div>
      </div>
    </div>
  );
}

export default function Cases() {
  return (
    <section className="dark-green-section py-20" id="cases">
      <div className="max-w-6xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 text-xs font-semibold mb-4">
          <Sparkles className="w-3.5 h-3.5" /> Resultados Reais
        </div>
        <h2 className="text-white text-3xl md:text-5xl font-extrabold">
          Cases de Sucesso <span className="gold-gradient-text">Comprovados</span>
        </h2>
        <p className="mt-4 text-slate-300 max-w-2xl mx-auto">
          Prints reais do aplicativo dos nossos licenciados. Resultados que falam por si.
        </p>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {cases.map((c) => (
            <div
              key={c.level}
              className={`relative rounded-2xl border ${c.borderColor} bg-gradient-to-br ${c.color} p-5 pt-6 backdrop-blur-sm hover:-translate-y-1 transition-transform`}
            >
              {c.isTop && (
                <div className="absolute top-3 right-3 text-[10px] font-extrabold bg-amber-400 text-black px-2 py-0.5 rounded">
                  TOP
                </div>
              )}
              <div className={`flex items-center gap-2 ${c.accent} font-semibold text-left`}>
                <Award className="w-4 h-4" /> {c.level}
              </div>
              <div className="mt-5">
                <PhoneMock level={c.displayName} saldo={c.saldo} holder={c.kwh} />
              </div>
              <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="rounded-lg bg-black/30 border border-white/10 p-3">
                  <div className="text-slate-300 text-[11px]">Total Acumulado</div>
                  <div className="text-white font-bold text-sm md:text-base mt-1">{c.total}</div>
                </div>
                <div className="rounded-lg bg-black/30 border border-white/10 p-3">
                  <div className="text-slate-300 text-[11px]">kWh Atingido</div>
                  <div className="text-emerald-400 font-bold text-sm md:text-base mt-1">{c.kwh}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm">
            Chamar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
